/**
 * Màu cho biểu đồ recharts theo chế độ sáng/tối.
 *
 * recharts nhận màu qua PROP, không ăn theo antd ConfigProvider cũng không ăn
 * theo class CSS — nên phải truyền tay. Không làm thì ở chế độ tối trục và lưới
 * vẫn màu xám nhạt của nền trắng, gần như biến mất.
 *
 * Dải `series` chọn theo thứ tự tương phản giảm dần trên nền tương ứng, và tránh
 * hai màu cạnh nhau dễ nhầm khi in đen trắng.
 */

export type ChartTheme = {
  axis: string;
  grid: string;
  tooltipBg: string;
  tooltipBorder: string;
  tooltipText: string;
  series: string[];
};

const LIGHT: ChartTheme = {
  axis: "#475569", // content-2
  grid: "#E2E8F0", // line
  tooltipBg: "#FFFFFF",
  tooltipBorder: "#E2E8F0",
  tooltipText: "#1E293B",
  series: ["#EE4D2D", "#2563EB", "#16A34A", "#D97706", "#7C3AED", "#DB2777"],
};

const DARK: ChartTheme = {
  axis: "#94A3B8", // content-2 bản tối
  grid: "#293548", // line bản tối
  tooltipBg: "#1E293B", // surface-muted, nổi hơn nền card
  tooltipBorder: "#475569",
  tooltipText: "#E2E8F0",
  // Bản sáng hơn + bớt bão hoà để không chói trên nền tối
  series: ["#FF6B4D", "#60A5FA", "#4ADE80", "#FBBF24", "#A78BFA", "#F472B6"],
};

export function getChartTheme(isDark: boolean): ChartTheme {
  return isDark ? DARK : LIGHT;
}
